export const getUrlParamsFromWorkflowstart = linkWorkflostart => {
  const isV1orV2 =
    linkWorkflostart?.includes('v1') || linkWorkflostart?.includes('v2');
  const firstSplit = linkWorkflostart?.split('/');
  const secondSplit = firstSplit?.[(isV1orV2 ? 4 : 3)].split('?');

  const url = [...firstSplit.slice(0, isV1orV2 ? 4 : 3), secondSplit[0]].join(
    '/',
  );
  const paramsArray = secondSplit.slice(1);
  const paramsList = paramsArray[0].split('&');
  const paramsObject = {};

  paramsList.forEach(parameter => {
    const [key, value] = parameter.split('=');
    paramsObject[key] = value;
  });

  return {
    url,
    paramsObject,
  };
};
